import type { FiguresPrompt } from '../generators/figures.ts'
import { FigureMatrix } from './FigureMatrix.tsx'

interface FiguresOptionsProps {
  options: FiguresPrompt['options']
  picks: [number | null, number | null]
  onPick: (blank: 0 | 1, index: number) => void
  disabled?: boolean
  /** Set after submission to reveal the correct options. */
  correct?: [number, number] | null
}

/** The two answer columns: three options under each blank ("Next" = frame 5,
 * "After that" = frame 6). Phones stack the columns via CSS. */
export function FiguresOptions({
  options,
  picks,
  onPick,
  disabled = false,
  correct = null,
}: FiguresOptionsProps) {
  const blanks: Array<[0 | 1, string]> = [
    [0, 'Next'],
    [1, 'After that'],
  ]
  return (
    <div className="figures-options">
      {blanks.map(([blank, label]) => (
        <div key={blank} className="figures-option-col" role="group" aria-label={`${label} options`}>
          <span className="figures-col-label">{label}</span>
          {options[blank].map((frame, i) => {
            const cls = [
              'figure-option',
              picks[blank] === i ? 'selected' : '',
              correct !== null && correct[blank] === i ? 'correct' : '',
            ]
              .filter(Boolean)
              .join(' ')
            return (
              <button
                key={i}
                type="button"
                className={cls}
                aria-pressed={picks[blank] === i}
                disabled={disabled}
                aria-label={`${label}: option ${i + 1}`}
                onClick={() => onPick(blank, i)}
              >
                <FigureMatrix frame={frame} label={`${label} option ${i + 1}`} />
              </button>
            )
          })}
        </div>
      ))}
    </div>
  )
}
